import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import PriceDisplay from '../../components/common/pricing/PriceDisplay';
import { activeCurrencySelector } from '../../selectors/CurrencySelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const Subtext = styled.span.withConfig({
  displayName: "FeatureTableFreePriceDisplay__Subtext",
  componentId: "lr9tbv-0"
})(["display:inline-block;font-weight:normal;margin-top:4px;font-size:0.875rem;"]);
const FeatureTableFreePriceDisplay = () => {
  //TODO: replace this selector with a non-redux way to get the currency
  const currencyCode = useSelector(activeCurrencySelector);
  return /*#__PURE__*/_jsx(Subtext, {
    className: "m-top-0",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "featureTable.pricing_jsx",
      elements: {
        PriceDisplay
      },
      options: {
        currencyCode,
        seleniumId: 'free',
        price: 0
      }
    })
  });
};
export default FeatureTableFreePriceDisplay;